import axios from '../API/axios';

export const getCollections = () => axios.get('webflow/footer');
